import { render } from "./firstScreen.vue?vue&type=template&id=9d04360e"
import script from "./firstScreen.vue?vue&type=script&lang=js"
export * from "./firstScreen.vue?vue&type=script&lang=js"

import "./firstScreen.vue?vue&type=style&index=0&id=9d04360e&lang=scss&scoop=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__